import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as S from './ReceivementPurchaseFilters.styles'
import * as selectors from '../../ReceivementSelectors'
import { useParams } from 'react-router-dom'
import { actions } from '../../ReceivementState'
import { Checkbox } from 'src/components/receivement-components/components'
import { ReceivementSearchInput } from '../ReceivementSearchInput'

const ReceivementPurchaseFilters = () => {
  const dispatch = useDispatch()

  const { receivementId } = useParams<{ receivementId?: string }>()
  const onlyDivergents = useSelector(selectors.selectOnlyDivergents)
  const [inputValue, setInputValue] = useState('')

  React.useEffect(() => {
    if (!receivementId) return
    dispatch(actions.getSalesOverview({ receivementId }))
  }, [dispatch, receivementId])

  React.useEffect(() => () => {
    dispatch(actions.clearOverviewFilters())
  }, [dispatch])

  const handleOnlyDivergents = React.useCallback(() => {
    dispatch(
      actions.setOnlyDivergentsFilter({ onlyDivergents: !onlyDivergents }),
    )
  }, [dispatch, onlyDivergents])

  const handleProductFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  const handleSearch = React.useCallback(() => {
    dispatch(actions.setProductDescriptionFilter({ productDescription: inputValue }))
  }, [dispatch, inputValue])

  return (
    <S.FiltersWrapper>
      <ReceivementSearchInput onChangeText={handleProductFilter} handleSearch={handleSearch}/>
      <S.SecondaryFiltersWrapper>
        <S.WrapperCheckbox>
          <Checkbox
            name='ars-filter'
            labelTitle='Ver somente ARs com divergência'
            checked={onlyDivergents}
            labelStyle={{
              marginLeft: '0.75rem',
              fontFamily: 'Work Sans',
              color: '#3B3B3B',
              fontSize: '14px',
            }}
            labelPosition='right'
            onChange={handleOnlyDivergents}
            style={{ width: '1rem', height: '1rem' }}
          />
        </S.WrapperCheckbox>
      </S.SecondaryFiltersWrapper>
    </S.FiltersWrapper>
  )
}

export { ReceivementPurchaseFilters }
